import { Component, Output, EventEmitter } from "@angular/core";

@Component({
  selector: "icn-close-btn",
  styleUrls: ["./close-btn.scss"],
  template: "",
  host: {
    "(click)": "onClick()",
  },
})
export class CloseButtonComponent {
  @Output()
  remove = new EventEmitter();

  onClick() {
    this.remove.emit();
  }
}
